import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1b62aeb8")
const _hoisted_1 = { class: "p-grid p-ai-center p-jc-center" }
const _hoisted_2 = { class: "p-col-12 p-md-auto p-d-flex p-flex-column p-ai-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "¡Ocurrió un error!", -1)
const _hoisted_4 = { class: "meme-container p-mb-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeBox = _resolveComponent("CodeBox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: require('@/assets/images/error/dog.jpg'),
          alt: "error"
        }, null, 8, _hoisted_5)
      ]),
      _createVNode(_component_CodeBox, {
        scrollHeightPx: _ctx.errorRef?.isAxiosError ? 200 : null
      }, {
        default: _withCtx(() => [
          _createElementVNode("u", null, _toDisplayString(_ctx.errorRef?.isAxiosError ? _ctx.errorRef?.message : _ctx.errorRef), 1),
          (_ctx.errorRef?.isAxiosError)
            ? (_openBlock(), _createElementBlock("pre", _hoisted_6, _toDisplayString(_ctx.errorRef.config), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["scrollHeightPx"]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          icon: "pi pi-arrow-left",
          class: " p-button-primary p-button-rounded p-mr-2",
          label: "Ir atrás",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-2)))
        }),
        _createVNode(_component_Button, {
          icon: "pi pi-home",
          class: " p-button-primary p-button-rounded p-button-outlined",
          label: "Ir al inicio",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: _ctx.CommonRouteNames.HOME_PAGE })))
        })
      ])
    ])
  ]))
}